import { startCase } from 'lodash';

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  PENDING_CLOSURE = 'PENDING_CLOSURE',
  FROZEN = 'FROZEN',
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
}

export enum VerificationStatus {
  NOT_PROVIDED = 'NOT_PROVIDED',
  REQUESTED = 'REQUESTED',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
}

const LABELS: Record<string, string> = {
  uuid: 'User ID',
};
export const getLabel = (key: string) => {
  if (key in LABELS) return LABELS[key];
  return startCase(key);
};

export interface ProfileHistory {
  createdAt: Date;
  changeReason?: string;
  changedBy?: string;
  record: Record<string, any>;
}

export interface KycHistory {
  createdAt: Date;
  changeReason?: string;
  changedBy?: string;
  record: Record<string, any>;
}

export interface OnboardingHistory {
  createdAt: Date;
  questions: Record<string, any>;
  answers: Record<string, string[]>;
}

export interface LoginHistory {
  createdAt: Date;
  success: boolean;
  ipAddress?: string;
  loginTransactionId?: string;
  deviceName?: string;
  authMethod?: string;
}

export interface ProfileHistoryResponse {
  profileHistory: ProfileHistory[];
  kycHistory: KycHistory[];
  onboardingHistory: OnboardingHistory[];
  loginHistory: LoginHistory[];
}

export interface Kyc {
  riskScoreAdjustment: number | null;
  onboarding: {
    onboarding: OnboardingHistory;
    onboardingAt: Date;
  };
  emailAddressVerificationStatus: VerificationStatus;
  phoneNumberVerificationStatus: VerificationStatus;
  riskScore: number | null;
  screeningPep: boolean | null;
  sourceOfFundsVerificationStatus: VerificationStatus;
  sourceOfFundsLastVerifiedAt: string | null;
  identities: Identity[];
}

export interface Identity {
  eidProviderType: string;
}
export interface AppUser {
  userId: string;
  firstName?: string;
  lastName: string;
  status: AccountStatus;
  externalReference: string;
  emailAddress: string;
  kyc: Kyc;
  loginCountry: string;
  personalIdNumber: string;
  createdAt: Date;
  interactions: string[];
  phoneNumber: string;
  addressStreetLine1: string;
  addressCity: string;
  addressPostalCode: string;
  addressCountryCode: string;
}

export interface AppUserMinimal {
  userId: string;
  firstName?: string;
  lastName: string;
  externalReference: string;
  emailAddress: string;
  kyc: Omit<Kyc, 'onboarding' | 'identities'>;
  loginCountry: string;
  createdAt: Date;
}
